module.exports = __webpack_public_path__ + "img/logo.d20b0d82.jpg";